import React from "react";
import AuthPage from "@/components/ui/AuthPage";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { connect } from "react-redux";
import useStyles from './RegisterConfirmationCardStyles';
import {
    Button,
    Container,
} from '@mui/material';
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    settings: any,
}

const RegisterConfirmationCard: React.FC<Props> = props => {

    const { classes } = useStyles()
    const history = useHistory();

    const {
        settings,
    } = props;

    const navigateHome = () => {
        let path = '/home';
        history.replace(path);
    }

    return (
        <AuthPage
            title="Thank you for creating an account with us!"
            icon={<MdOutlineMarkEmailRead />}
            actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateHome}>Return to Home</button>}>
            <p>Please check your email and confirm your account via the link provided within the confirm account email.</p>
            <p>If you do not receive an email within a few minutes, please check your <strong>spam folder</strong>.</p>
        </AuthPage>
    )

}

const mapStateToProps = (state: any) => ({
    settings: state.settings.settings,
});

export default connect(mapStateToProps)(RegisterConfirmationCard);
